<template>
  <div>
    <header-slot>
      <template #content-right>
        <div>
          <b-button
            @click="$refs['component-entity-group'].editEntityGroup({}, true)"
            v-t="'CREATE'"
            class="mr-1"
            variant="outline-success"
          ></b-button>
          <b-button
            variant="outline-warning"
            @click="updateEntityGroupWithOldSoft"
          > {{$t('UPDATE ENTITY GROUPS') }}</b-button>
        </div>
      </template>
    </header-slot>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <EntityGroupTable ref="component-entity-group" />
    </b-card>
  </div>
</template>

<script>
/* Components */
import EntityGroupTable from "@/views/settings/views/entity-group/components/EntityGroupTable.vue";
import EntityGroupService from "@/views/settings/views/entity-group/service/entity-group.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    EntityGroupTable,
  },
  methods: {
    async updateEntityGroupWithOldSoft() {
      try {
        this.addPreloader();
        const form_params = new URLSearchParams();
        form_params.append(
          "data",
          JSON.stringify({
            token: "sfgdshfiuhfgsd7w9t874w9erfhu54k435df",
          })
        );
        const { data } = await EntityGroupService.getEntityGroupsOldSoft(
          form_params
        );
        if (data.personals.length) {
          const details = [];
          data.personals.map((item) => {
            if (item.details != null) {
              const det = JSON.parse(item.details);
              det.map((item2) => details.push(item2));
            }
          });
          const params = {
            groups: JSON.stringify(data.personals),
            viatics: JSON.stringify(data.viatics),
            detail: JSON.stringify(details),
          };
          const data2 = await EntityGroupService.updateEntityGroups(params);
          this.$toast({
            component: ToastificationContent,
            position: "top-center",
            props: {
              title: "Success",
              icon: "CoffeeIcon",
              variant: "success",
              text: `Subgrupos actualizados`,
            },
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style>
</style>